import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret-down-small",
  "use": "caret-down-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"caret-down-small\"><g><g transform=\"matrix(1,2.2884755665834912e-17,-2.2884755665834912e-17,1,0,0)\"><path d=\"M11,6C11,6,5,6,5,6C5,6,8,10.5,8,10.5C8,10.5,11,6,11,6Z\" fill=\"#232A35\" fill-opacity=\"0.8500000238418579\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol